/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sorgente del valore confrontato dal predicato
 */
export enum FontePredicato {

    ATTRIBUTO = 'ATTRIBUTO',

    ETA_COMPONENTE = 'ETA_COMPONENTE',

    NUMERO_COMPONENTI = 'NUMERO_COMPONENTI',

    ISEE_PRATICA = 'ISEE_PRATICA',

    ORDINAMENTO_SCUOLA_COMPONENTE = 'ORDINAMENTO_SCUOLA_COMPONENTE',

    CLASSE_COMPONENTE = 'CLASSE_COMPONENTE',

    TIMESTAMP_RICHIESTA_PRATICA = 'TIMESTAMP_RICHIESTA_PRATICA'
}

